import React, { useState } from "react";
import PropTypes from "prop-types";
import { lookupTicker } from "./tickerData";
import "./Ticker.css";

function badgeColor(symbol) {
  let h = 0;
  for (const c of symbol) h = (h * 31 + c.charCodeAt(0)) % 360;
  return `hsl(${h}, 55%, 45%)`;
}

export default function TickerIcon({ symbol, size = 20 }) {
  const sym = String(symbol || "").toUpperCase();
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size };

  if (lookupTicker(sym)?.l && !failed) {
    return (
      <img
        className="tkIcon"
        src={`${process.env.PUBLIC_URL}/logos/${sym}.png`}
        alt=""
        style={style}
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <span
      className="tkIcon tkIcon--badge"
      style={{ ...style, background: badgeColor(sym), fontSize: Math.round(size * 0.5) }}
      aria-hidden="true"
    >
      {sym.charAt(0)}
    </span>
  );
}

TickerIcon.propTypes = {
  symbol: PropTypes.string.isRequired,
  size: PropTypes.number,
};
